<template>
  <div>
    <h1>Lead Time Penerimaan Dealer</h1>
    <hr>

    <!-- FILTER STARTS -->
    <flexibleFilter
      :dealer_type="'DEALER'"
      :simple_date="true"
      :fetch_filter="fetchFilter"
      @onFilter="setFilterUrl"
    ></flexibleFilter>
    <!-- FILTER ENDS -->

    <!-- Lead Time Delivery Start -->
    <div class="innerBox mt-5">
      <h5 class="mb-2">Lead Time Penerimaan Dealer</h5>
      <lead-time-delivery-chart
        :filterUrl="filterUrl"
      ></lead-time-delivery-chart>
    </div>
    <!-- Lead Time Delivery End -->
  </div>
</template>

<script>
  import flexibleFilter from '@/components/filter/flexible_filter.vue'

  import leadTimeDeliveryChart from './children/leadTimeDeliveryChart'

  export default {
    data () {
      return {
        filterUrl : '',
        fetchFilter : 0,
      }
    },
    components : {
      flexibleFilter,
      leadTimeDeliveryChart,
    },
    mounted () {
      this.fetchFilter++;
    },
    methods : {
      setFilterUrl(a){
        this.filterUrl = a
      }
    }
  }
</script>

<style scoped>
  
</style>